import Container from '../components/Container';

export default function Home() {
  return (
    <Container>
      <div className="text-4xl">Home</div>
    </Container>
  );
}
